"use strict";

var _defineProperty = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Products2Cell;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _agenda2Themes = require("./agenda2Themes");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  })(e, t);
}
// Produits 2.0: an alphabetical list of items (speakers, exhibitors, products...) with a photo, a name and a
// subtitle; a tab bar groups them by their `category` text ("A", "B-C"...), and a card opens a popup with the
// rich description. The items belong to the cell itself (products2_items), imported from a CSV or edited by hand.

var ALL = '__all__';
var DEFAULT_FONT = "OpenSans-Regular, 'Open Sans', sans-serif";
var compare = function compare(a, b) {
  return String(a).localeCompare(String(b), undefined, {
    numeric: true,
    sensitivity: 'base'
  });
};
var ALL_LABELS = {
  fr: 'Tous',
  nl: 'Alle'
};
function Products2Cell(_ref) {
  var cell = _ref.cell,
    intl = _ref.intl,
    _ref$uriTransformer = _ref.uriTransformer,
    uriTransformer = _ref$uriTransformer === void 0 ? function (u) {
      return u;
    } : _ref$uriTransformer;
  var allLabel = ALL_LABELS[intl && intl.locale ? intl.locale.slice(0, 2) : 'en'] || 'All';
  var items = (0, _react.useMemo)(function () {
    return _toConsumableArray(cell.items || []).sort(function (a, b) {
      return compare(a.name || '', b.name || '');
    });
  }, [cell.items]);
  var categories = (0, _react.useMemo)(function () {
    return _toConsumableArray(new Set(items.map(function (item) {
      return item.category || '';
    }).filter(Boolean))).sort(compare);
  }, [items]);

  // Items without a category are only reachable through "All": show that tab whenever there are some.
  var hasUncategorized = items.some(function (item) {
    return !item.category;
  });
  var showAllTab = categories.length > 0 && (cell.show_all_tab !== false || hasUncategorized);
  var showTabs = categories.length > 0;
  var _ref2 = (0, _react.useState)(null),
    _ref3 = _slicedToArray(_ref2, 2),
    picked = _ref3[0],
    setPicked = _ref3[1];
  var _ref4 = (0, _react.useState)(null),
    _ref5 = _slicedToArray(_ref4, 2),
    current = _ref5[0],
    setCurrent = _ref5[1];
  var selected = function () {
    if (!showTabs) return ALL;
    if (picked === ALL && showAllTab) return ALL;
    if (categories.includes(picked)) return picked;
    return showAllTab ? ALL : categories[0];
  }();
  var shown = selected === ALL ? items : items.filter(function (item) {
    return item.category === selected;
  });
  var customBackground = cell.background_image_uri ? uriTransformer(cell.background_image_uri) : null;
  var backgroundImageUri = customBackground || (cell.color_theme === 'euroseeds' ? _agenda2Themes.EUROSEEDS_BACKGROUND : null);
  var backgroundSize = customBackground ? {
    contain: 'contain',
    stretch: '100% 100%'
  }[cell.background_fit] || 'cover' : 'cover';
  var backgroundImageStyle = backgroundImageUri ? {
    backgroundImage: 'url("' + backgroundImageUri + '")',
    backgroundSize: backgroundSize,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  } : {};
  var radius = function radius(enabled, size) {
    return enabled ? size / 2 + 0.5 + 'em' : '0em';
  };
  var pill = function pill(isSelected) {
    return {
      flex: '1 0 auto',
      cursor: 'pointer',
      padding: '0.4em 0.3em',
      fontSize: cell.font_size_filter + 'em',
      fontWeight: 'bold',
      textAlign: 'center',
      whiteSpace: 'nowrap',
      transitionDuration: '200ms',
      background: isSelected ? cell.background_color_filter_checked : 'rgba(0,0,0,0)',
      color: isSelected ? cell.text_color_filter_selected : cell.text_color_filter,
      border: 'solid 0.1em ' + (isSelected ? cell.border_color_selected_filter : 'rgba(0,0,0,0)'),
      borderRadius: radius(cell.bolder_radius_filter, cell.font_size_filter)
    };
  };

  // Many tabs (A, B-C ... U-W) do not fit on one line: split them over two rows of equal width.
  var tabCount = categories.length + (showAllTab ? 1 : 0);
  var twoRows = tabCount > 6;
  var tabBar = showTabs && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: twoRows ? 'grid' : 'flex',
      gridTemplateColumns: twoRows ? 'repeat(' + Math.ceil(tabCount / 2) + ', 1fr)' : undefined,
      overflowX: twoRows ? 'visible' : 'auto',
      boxSizing: 'border-box',
      gap: '0.3em',
      padding: '0.35em',
      marginBottom: '0.8em',
      borderRadius: radius(cell.bolder_radius_filter, cell.font_size_filter * (twoRows ? 1.2 : 2)),
      border: 'solid 1px ' + cell.border_color_selected_filter,
      backgroundColor: cell.background_color_filter
    }
  }, showAllTab && /*#__PURE__*/_react.default.createElement("div", {
    style: pill(selected === ALL),
    onClick: function onClick() {
      return setPicked(ALL);
    }
  }, allLabel), categories.map(function (category) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: category,
      style: pill(selected === category),
      onClick: function onClick() {
        return setPicked(category);
      }
    }, category);
  }));
  var hasPopup = function hasPopup(item) {
    return !!(item.description || item.image_uri);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread(_objectSpread({
      padding: '4%',
      boxSizing: 'border-box',
      width: '100%',
      minHeight: '100%',
      backgroundColor: cell.background_color
    }, backgroundImageStyle), {}, {
      color: cell.text_color,
      fontFamily: cell.font_family || DEFAULT_FONT
    })
  }, tabBar, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      maxHeight: (cell.list_max_height_vh || 70) + 'vh',
      overflowY: 'auto',
      overflowX: 'hidden'
    }
  }, shown.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: item.id,
      role: hasPopup(item) ? 'button' : undefined,
      onClick: hasPopup(item) ? function () {
        return setCurrent(item);
      } : undefined,
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.9em',
        boxSizing: 'border-box',
        padding: '0.7em',
        marginBottom: '0.6em',
        borderRadius: '0.7em',
        border: 'solid 1px ' + cell.border_color_card,
        backgroundColor: cell.background_color_card,
        cursor: hasPopup(item) ? 'pointer' : 'default'
      }
    }, item.image_uri && /*#__PURE__*/_react.default.createElement("img", {
      src: uriTransformer(item.image_uri),
      alt: "",
      style: {
        flex: '0 0 auto',
        width: cell.image_size + 'em',
        height: cell.image_size + 'em',
        objectFit: 'cover',
        borderRadius: '0.5em'
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 1,
        minWidth: 0
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: cell.text_color_name,
        fontWeight: 'bold',
        fontSize: cell.font_size_name + 'em',
        lineHeight: 1.3
      }
    }, item.name), item.subtitle && /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: cell.text_color_subtitle,
        fontSize: cell.font_size_subtitle + 'em',
        marginTop: '0.25em',
        lineHeight: 1.35
      }
    }, item.subtitle)), hasPopup(item) && /*#__PURE__*/_react.default.createElement("span", {
      style: {
        flex: '0 0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '1.6em',
        height: '1.6em',
        fontWeight: 'bold',
        borderRadius: '50%',
        color: cell.text_color_name,
        border: 'solid 0.08em ' + cell.text_color_name
      }
    }, "+"));
  })), current && /*#__PURE__*/_react.default.createElement(PopUp, {
    item: current,
    cell: cell,
    uriTransformer: uriTransformer,
    close: function close() {
      return setCurrent(null);
    }
  }));
}
function PopUp(_ref6) {
  var item = _ref6.item,
    cell = _ref6.cell,
    uriTransformer = _ref6.uriTransformer,
    close = _ref6.close;
  // Portal to <body>: the page grid (react-grid-layout) positions every cell with a CSS transform, which turns
  // `position: fixed` into "fixed to the cell": the popup then opened below the cell's top and could not scroll.
  return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react.default.createElement("div", {
    onClick: close,
    style: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.6)',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    style: {
      position: 'relative',
      boxSizing: 'border-box',
      width: '88%',
      maxWidth: '40em',
      maxHeight: '85vh',
      overflowY: 'auto',
      padding: '1.2em',
      borderRadius: '0.6em',
      boxShadow: '0 1em 2em rgba(0,0,0,0.4)',
      backgroundColor: cell.background_color_pop_up,
      color: cell.text_color_pop_up,
      fontFamily: cell.font_family || DEFAULT_FONT
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    onClick: close,
    role: "button",
    style: {
      position: 'absolute',
      top: '0.4em',
      right: '0.7em',
      cursor: 'pointer',
      fontSize: '1.4em',
      color: cell.color_button_close
    }
  }, "\u2715"), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '1em',
      margin: '0 1.5em 0.8em 0'
    }
  }, item.image_uri && /*#__PURE__*/_react.default.createElement("img", {
    src: uriTransformer(item.image_uri),
    alt: "",
    style: {
      flex: '0 0 auto',
      width: '6em',
      height: '6em',
      objectFit: 'cover',
      borderRadius: '0.5em'
    }
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: cell.text_color_pop_up_title,
      fontWeight: 'bold',
      fontSize: cell.font_size_name * 1.2 + 'em',
      lineHeight: 1.3
    }
  }, item.name), item.subtitle && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '0.25em',
      fontSize: cell.font_size_popup + 'em',
      opacity: 0.8
    }
  }, item.subtitle))), item.description && /*#__PURE__*/_react.default.createElement("div", {
    className: "tsk-html-description",
    style: {
      fontSize: cell.font_size_popup + 'em',
      lineHeight: 1.5
    }
  }, /*#__PURE__*/_react.default.createElement("style", null, ".tsk-html-description ul{display:block !important;list-style:disc !important;padding-left:1.4em !important;margin:0.4em 0 !important}.tsk-html-description ol{display:block !important;list-style:decimal !important;padding-left:1.4em !important;margin:0.4em 0 !important}.tsk-html-description li{display:list-item !important;list-style:inherit !important}"), /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: item.description
    }
  })))), document.body);
}